import React from 'react'
import { Layout, ScrollToTopButton } from 'packages/eid-ui'
import AppHeader from './AppHeader'
import AppGlobalMenu from './AppGlobalMenu'
import { useApplicationSettings } from 'hooks'
import SubHeader from 'components/SubHeader'
import { useIsSmallScreen, useQuery } from 'packages/core'
import { mobileScreenWidth, tabletScreenWidth } from 'utils'
import { Box, styled } from '@mui/material'
import ScrollToTop from 'react-scroll-up'
import { useTranslation } from 'react-i18next'
import config from 'config'
import { headerHeight } from 'utils'

const subHeaderHeight = 70

const SubHeaderContainer = styled(Box)(
    ({ hideHeader, hideSideNavigation, isSmallScreen }) => ({
        position: 'fixed',
        top: hideHeader ? 0 : headerHeight,
        width: '100%',
        maxWidth: '1920px',
        height: '80px',
        display: 'flex',
        alignItems: 'end',
        paddingTop: '0',
        paddingRight: isSmallScreen ? '0px' : '20px',
        paddingLeft: isSmallScreen
            ? '0px'
            : hideSideNavigation
            ? '25px'
            : '90px',
        backgroundColor: 'transparent',
        zIndex: 1099,

        '&::before': {
            content: '""',
            display: 'block',
            backgroundColor: 'rgb(238, 240, 244)',
            position: 'absolute',
            left: 0,
            top: '-4px',
            width: '100%',
            height: 'calc(100% + 1px)',
        },
    }),
)

const createStyles = (
    headerConfig,
    hideHeader,
    hideSideNavigation,
    isSmallScreen,
) => {
    return {
        rootStyles: {
            position: 'relative',
            paddingBottom: '30px',

            overflowY: 'overlay !important',

            //'ms-overflow-y': 'scroll !important',
            [`@media (max-width:${mobileScreenWidth})`]: {
                top: hideHeader ? 0 : headerConfig.mobile?.height,
            },
            [`@media (min-width:${tabletScreenWidth})`]: {
                top: hideHeader ? 0 : headerConfig.desktop?.height,
            },
            '@media (min-width:1023px)': {
                top: `calc(${
                    hideHeader ? '0px' : headerConfig.desktop?.height
                } + ${subHeaderHeight}px)`,
            },
        },

        rootMenuStyles: {
            top: hideHeader ? '0' : headerConfig.desktop?.height,
            // '@media (max-width:1024px)': {
            //     minWidth: '60px',
            // },
            // '@media (max-width:1024px) and (orientation: landscape)': {
            //     minWidth: '80px',
            // },
        },
        contentContainerStyles: {
            ...(!isSmallScreen && hideSideNavigation && { marginLeft: '17px' }),
        },
    }
}

const scrollToTopButtonStyles = { bottom: 20, right: 20, zIndex: 2 }
const AppLayout = ({ children, totalCount, viewSwitcher }) => {
    const { t } = useTranslation()
    const { data: appConfig } = useApplicationSettings()

    const isSmallScreen = useIsSmallScreen()

    const query = useQuery()
    const id = query.get('id')

    const headerConfig = appConfig.style.header
    const hideHeader = appConfig.style.header.hide
    const hideSideNavigation = appConfig.style.hideSideNavigation
    const styles = createStyles(
        headerConfig,
        hideHeader,
        hideSideNavigation,
        isSmallScreen,
    )

    const scrollToTopComponent = (
        <ScrollToTop showUnder={160} style={scrollToTopButtonStyles}>
            <ScrollToTopButton size="medium" label={t('BackToTop')} />
        </ScrollToTop>
    )

    return (
        <Layout
            header={!hideHeader && <AppHeader />}
            globalMenu={
                isSmallScreen && id ? (
                    <></>
                ) : (
                    <AppGlobalMenu hideSideNavigation={hideSideNavigation} />
                )
            }
            rootMenuStyles={styles.rootMenuStyles}
            rootStyles={styles.rootStyles}
            contentContainerStyles={styles.contentContainerStyles}
            subHeader={
                !isSmallScreen && (
                    <SubHeaderContainer
                        hideHeader={hideHeader}
                        hideSideNavigation={hideSideNavigation}
                    >
                        <SubHeader
                            totalCount={totalCount}
                            viewSwitcher={viewSwitcher}
                        />
                    </SubHeaderContainer>
                )
            }
            children={children}
            scrollToTopComponent={
                config.SHOW_SCROLL_TO_TOP && scrollToTopComponent
            }
        />
    )
}

export default AppLayout
